import React from "react";
import PrivacyPolicy from "../components/Footer/PrivacyPolicy";

function PrivacyPolicyPage() {
  return (
    <div>
      <PrivacyPolicy />
    </div>
  );
}

export default PrivacyPolicyPage;
